import Assert from "tbAssert";

const mainPageTitle = "TrackerBase: TrackerBase Reports Home";

class TrackingReportsMainPageController {
    constructor($document) {
        Assert.StrictAssert($document != null, "Assertion Failure: Missing Document Service Dependency");

        $document.attr("title", mainPageTitle);
    }
}

TrackingReportsMainPageController.$inject = [ "$document" ];

TrackingReportsMainPageController.dependencies = [
    "ngSanitize",
    "ngAnimate",
    "ngAria"
];

TrackingReportsMainPageController.template = require("./ReportsMainPage.tpl.html");

TrackingReportsMainPageController.controllerAs = "reportsViewMainPage";

export default TrackingReportsMainPageController;



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-reports/ReportsMainPageController.js
// module id = j6g/
// module chunks = 1